/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, ProxyContext } from '../twd/all'

export const Disclaimer = ({context}) => {

    return <React.Fragment>
        <div className="row vertical-offset-sm">
        <div className="col-md-12 col-xs-12">
            <h2 className="modal-title text-center vertical-offset-sm">TRACE Real-Time Data Agreement</h2>

            <p>I hereby certify, for the purpose of using the Trade Reporting and Compliance Engine (TRACE) Data ("Data")
      supplied by Financial Industry Regulatory Authority ("FINRA") that I am accessing via this website, that <b>I am using
      the Data for personal, non-commercial purposes only.</b></p>

            <p>I agree that FINRA owns the Data and that I will not: 1) duplicate or download the Data, other than for my own
      personal individual use; 2) use any robot, spider, other automatic device or manual process to monitor or copy the
      Data; or 3) otherwise distribute the Data.</p>

            <p>I understand that FINRA may track my use to confirm compliance with these Terms of Use and that my access to this
      Data may be terminated at any time for any reason.</p>

            <p>By clicking the "Agree" button, I certify that I understand and agree to all the terms set forth above.</p>
        </div>
        </div>

        <div className="row">
        <div className="col-12 text-center">
            <button
                type="button"
                className="btn btn-primary"
                style={{margin:'5px'}}
                onClick={() => {
                    ProxyContext.destroy('trade-history')
                    hideModal()
                }}
            >Decline</button>
            <button
                type="button"
                className="btn btn-primary"
                style={{margin:'5px'}}
                onClick={() => {
                    ProxyContext.get('trade-history').attestDisclaimer()
                }}
            >Agree</button>
        </div>
        </div>
    </React.Fragment>
}
